export default "__VITE_ASSET__CnKttyfT__"